import { IRoomRepository } from '../ports/IRoomRepository';
import { isValidCard } from '../../domain/valueObjects/FibonacciDeck';
import { isValidTShirtCard } from '../../domain/valueObjects/TShirtDeck';
import { DeckType } from '../../domain/entities/Room';

export class VoteUseCase {
  constructor(private roomRepo: IRoomRepository) {}

  async execute(
    roomId: string,
    userId: string,
    vote: string,
    deckType: DeckType = 'fibonacci'
  ): Promise<void> {
    const valid = deckType === 'tshirt' ? isValidTShirtCard(vote) : isValidCard(vote);
    if (!valid) {
      throw new Error(`Carta inválida: ${vote}`);
    }
    await this.roomRepo.submitVote(roomId, userId, vote);
  }
}
